<template>
    <v-container fluid>
        <v-layout>
            <v-flex>
                <h2>Últimas rondas</h2>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-data-table
                    :headers="headers"
                    :items="filteredRounds"
                    :hide-actions="true"
                    :disable-initial-sort="true"
                >
                    <template v-slot:no-data>
                        <v-alert :value="true" color="error" icon="warning">
                            No ha realizado rondas previas
                        </v-alert>
                    </template>
                    <template slot="items" slot-scope="{ item }">
                        <td>{{ item.round.client.name }}</td>
                        <td>{{ item.round.name }}</td>
                        <td>{{ item.start_date | datetime }}</td>
                        <td>{{ item.end_date | datetime }}</td>
                        <td>{{ !!item.end_date ? 'Si' : 'No' }}</td>
                        <td>{{ !item.incomplete ? 'Si' : 'No' }}</td>
                        <td>{{ item.duration }}</td>
                        <td>{{ item.notes }}</td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import roundRepository from '../../../repositories/round.repository'
import { mapGetters, mapActions } from 'vuex'
export default {
    data: () => ({
        headers,
    }),
    computed: {
        ...mapGetters(['lastRounds']),
        filteredRounds() {
            return this.lastRounds.filter(item => !!item.round)
        },
    },
    methods: {
        ...mapActions(['loadLastRounds']),
    },
    mounted() {
        this.loadLastRounds()
    },
}

const headers = [
    {
        text: 'Cliente',
        value: 'round.client.name',
    },
    {
        text: 'Ronda',
        value: 'round.name',
    },
    {
        text: 'Fecha Inicio',
        value: 'start_date',
    },
    {
        text: 'Fecha Fin',
        value: 'end_date',
    },
    {
        text: 'Finalizada',
        value: 'finished',
    },
    {
        text: 'Completa',
        value: 'complete',
    },
    {
        text: 'Duración (mins)',
        value: 'duration',
    },
    {
        text: 'Notas',
        value: 'notes',
    },
]
</script>
